import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { TABLES } from '../../../../../Apis/Tables';
import { VIEW_TYPE } from '../../../../../enums/ViewType';
import { useParamsContextProvider } from '../../../../../hooks/ParamsContextProvider';
import { TABS_FOODIE } from '../../Model/Models';
import { DeleteItemsApi } from './../../../../../reduxToolkit/Commons/CommonsApi';
import { errorMsg } from '../../../../../Apis/functions';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */

const DishesApp = ({ setModified }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    // State variables for UI and logic

    const [isAllChecked, setIsAllChecked] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const { paramsContext, setParamsContext } = useParamsContextProvider();

    // Close delete modal and reset context
    const handleDeleteModalClose = () => {
        if (setParamsContext) {
            setParamsContext((prev) => ({
                ...prev,
                modalDelete: false,
            }));
        }
    };
    // Deletes selected dish IDs from the API
    const handleDeleteSelected = () => {
        if (selectedList.length > 0) {
            const tableName = TABLES.DISH;
            const body = selectedList;

            dispatch(DeleteItemsApi({ tableName, body })).then(
                ({
                    payload: {
                        data: { success, code },
                    },
                }) => {
                    if (success === true) {
                        setModified(true);
                        setSelectedList([]);
                        setIsAllChecked(false);
                        handleDeleteModalClose();
                    } else {
                        errorMsg(code);
                    }
                },
            );
        }
    };

    // Show modal if delete flag is set and a tab is active
    useEffect(() => {
        if (paramsContext && paramsContext?.tabIndex == TABS_FOODIE.DISHES.INDEX && selectedList?.length > 0)
            setDeleteModalShow(paramsContext.modalDelete);
    }, [paramsContext]);

  // Clear selected items when the delete modal is closed
     useEffect(() => {
         if (!deleteModalShow) setSelectedList([]);
     }, [deleteModalShow]);

    // Disable or enable delete button based on selected items
    useEffect(() => {
        if (paramsContext && paramsContext?.tabIndex == TABS_FOODIE.DISHES.INDEX) {
            setParamsContext((prev) => ({
                ...prev,
                disabledBtnDelete: selectedList?.length <= 0,
            }));
        }
    }, [selectedList]);


    return {
        t,
        deleteModalShow,
        handleDeleteSelected,
        handleDeleteModalClose,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        view,
        setView,
    };
};

export default DishesApp;
